<template>
  <div>
    <div class="container">
      <div class="card card-custom mt-5">
        <div class="card-body py-8">
          <!--begin: Wizard-->
          <div
            class="wizard wizard-3"
            id="kt_wizard"
            data-wizard-state="first"
            data-wizard-clickable="true"
          >
            <!--begin: Wizard Nav-->
            <div class="wizard-nav">
              <div class="wizard-steps px-8 py-5 px-lg-8 py-lg-7">
                <!--begin::Wizard Step 1 Nav-->
                <div
                  @click="toggle_step(1)"
                  id="step_1"
                  class="wizard-step"
                  data-wizard-type="step"
                  :data-wizard-state="
                    current_step == 1
                      ? 'current'
                      : current_step > 1
                      ? 'done'
                      : 'pending'
                  "
                >
                  <div class="wizard-label">
                    <span class="wizard-number">1</span>
                    <span class="wizard-check">
                      <span class="svg-icon svg-icon-2x">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          version="1.1"
                        >
                          <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <polygon points="0 0 24 0 24 24 0 24"></polygon>
                            <path
                              d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                              fill="#000000"
                              fill-rule="nonzero"
                              transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "
                            ></path>
                          </g>
                        </svg>
                      </span>
                    </span>
                  </div>
                  <div class="wizard-title">INFORMATIONS PERSONNELLES</div>
                </div>
                <!--end::Wizard Step 1 Nav-->

                <!--begin::Wizard Step 2 Nav-->
                <div
                  @click="toggle_step(2)"
                  id="step_2"
                  class="wizard-step"
                  data-wizard-type="step"
                  :data-wizard-state="
                    current_step == 2
                      ? 'current'
                      : current_step > 2
                      ? 'done'
                      : 'pending'
                  "
                >
                  <div class="wizard-label">
                    <span class="wizard-number">2</span>
                    <span class="wizard-check">
                      <span class="svg-icon svg-icon-2x">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          version="1.1"
                        >
                          <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <polygon points="0 0 24 0 24 24 0 24"></polygon>
                            <path
                              d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                              fill="#000000"
                              fill-rule="nonzero"
                              transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "
                            ></path>
                          </g>
                        </svg>
                      </span>
                    </span>
                  </div>
                  <div class="wizard-title">INFORMATIONS BANCAIRES</div>
                </div>
                <!--end::Wizard Step 2 Nav-->

                <!--begin::Wizard Step 3 Nav-->
                <div
                  @click="toggle_step(3)"
                  id="step_3"
                  class="wizard-step"
                  data-wizard-type="step"
                  :data-wizard-state="
                    current_step == 3
                      ? 'current'
                      : current_step > 3
                      ? 'done'
                      : 'pending'
                  "
                >
                  <div class="wizard-label">
                    <span class="wizard-number">3</span>
                    <span class="wizard-check">
                      <span class="svg-icon svg-icon-2x">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          version="1.1"
                        >
                          <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <polygon points="0 0 24 0 24 24 0 24"></polygon>
                            <path
                              d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                              fill="#000000"
                              fill-rule="nonzero"
                              transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "
                            ></path>
                          </g>
                        </svg>
                      </span>
                    </span>
                  </div>
                  <div class="wizard-title">DOCUMENTS</div>
                </div>
                <!--end::Wizard Step 3 Nav-->
              </div>
            </div>
            <!--end: Wizard Nav-->

            <!--begin: Wizard Body-->
            <div class="row justify-content-center">
              <div class="col-xl-12 col-xxl-10">
                <!--begin: Wizard Form-->
                <form
                  class="form fv-plugins-bootstrap fv-plugins-framework"
                  id="kt_form"
                >
                  <!--begin: Wizard Step 1-->
                  <div
                    id="content_step_1"
                    class="pb-5"
                    data-wizard-type="step-content"
                    :data-wizard-state="
                      current_step == 1
                        ? 'current'
                        : current_step > 1
                        ? 'done'
                        : 'pending'
                    "
                  >
                    <div class="card-body">
                      <form method="POST" enctype="multipart/form-data">
                        <div class="row d-flex justify-content-center">
                          <div class="attestations-files">
                            <div class="card-body text-center">
                              <h5 class="card-title">Photo</h5>
                              <div class="attestation-file mb-5">
                                <div
                                  class="image-input image-input-outline"
                                  id="kt_image_1"
                                >
                                  <img
                                    class="image-input-wrapper"
                                    :src="getProfilePhoto()"
                                    style="width: 260px; height: 260px"
                                    id="oldImageProfile"
                                  />
                                  <img
                                    class="image-input-wrapper"
                                    :src="imageProfilPreview"
                                    id="newImageProfilDiv"
                                    style="width: 260px; height: 260px"
                                    :style="{
                                      display: showProfil ? 'block' : 'none',
                                    }"
                                  />
                                  <label
                                    class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                    data-action="change"
                                    data-toggle="tooltip"
                                    title=""
                                    data-original-title="Changer photo profil"
                                  >
                                    <i class="fa fa-pen icon-sm text-muted"></i>
                                    <input
                                      type="file"
                                      name="photo"
                                      @change="onImageProfilChange"
                                      accept=".png, .jpg, .jpeg"
                                    />
                                  </label>
                                </div>

                                <h4 style="color: #ceda00; margin-top: 10px">
                                  {{ vacataire.nom }} {{ vacataire.prenom }}
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="form-group row">
                          <div class="col-lg-4">
                            <label>
                              CIN<span style="color: #ee2d41">*</span>
                            </label>
                            <input
                              type="text"
                              name="cin"
                              value="vacataire.cin"
                              v-model.trim="$v.vacataire.cin.$model"
                              class="form-control"
                              :class="{
                                'is-invalid': errors.cin,
                              }"
                            />
                            <div style="color: red" v-if="errors.cin">
                              {{ errors.cin[0] }}
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <label>PASSPORT</label>
                            <input
                              type="text"
                              v-model="vacataire.passport"
                              name="passport"
                              class="form-control"
                            />
                          </div>
                          <div class="col-lg-4">
                            <label
                              >TÉLÉPHONE<span style="color: #ee2d41"
                                >*</span
                              ></label
                            >
                            <input
                              type="text"
                              name="tel"
                              v-model.trim="$v.vacataire.tel.$model"
                              class="form-control"
                              :class="{
                                'is-invalid': errors.tel,
                              }"
                            />
                            <div style="color: red" v-if="errors.tel">
                              {{ errors.tel[0] }}
                            </div>
                            <div style="color: red" v-if="errors.tel">
                              {{ errors.tel[1] }}
                            </div>
                          </div>
                        </div>
                        <div class="form-group row">
                          <div class="col-lg-4">
                            <label
                              >DATE DE NAISSANCE<span style="color: #ee2d41"
                                >*</span
                              >
                            </label>
                            <datepicker
                              v-model.trim="$v.vacataire.date_naissance.$model"
                              name="date_naissance"
                              format="yyyy-MM-dd"
                              :inputClass="`{
                                'is-invalid': errors.date_naissance,
                              }`"
                              bootstrapStyling
                            />
                            <div
                              style="color: red"
                              v-if="errors.date_naissance"
                            >
                              {{ errors.date_naissance[0] }}
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <label
                              >PAYS D'ORIGINE<span style="color: #ee2d41"
                                >*
                              </span>
                            </label>
                            <select
                              name="pays_id"
                              class="selectpicker"
                              data-width="100%"
                              data-live-search="true"
                              v-model.trim="$v.vacataire.pays_id.$model"
                              :class="{
                                'is-invalid': errors.pays_id,
                              }"
                            >
                              <option
                                :selected="vacataire.pays_id == null"
                                value="149"
                              >
                                Morocco
                              </option>
                              <option
                                v-for="pay in pays"
                                :key="pay.id"
                                :selected="pay.id == vacataire.pays_id"
                                :value="pay.id"
                              >
                                {{ pay.nom }}
                              </option>
                            </select>

                            <div style="color: red" v-if="errors.pays_id">
                              {{ errors.pays_id[0] }}
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <label
                              >ADRESSE<span style="color: #ee2d41"
                                >*</span
                              ></label
                            >
                            <input
                              type="text"
                              name="adresse"
                              v-model.trim="$v.vacataire.adresse.$model"
                              class="form-control"
                              :class="{
                                'is-invalid': errors.adresse,
                              }"
                            />
                            <div style="color: red" v-if="errors.adresse">
                              {{ errors.adresse[0] }}
                            </div>
                          </div>
                        </div>
                        <div class="form-group row">
                          <div class="col-lg-4">
                            <label
                              >Email personnelle<span
                                v-if="vacataire.email_uir == null"
                                style="color: #ee2d41"
                                >*</span
                              >
                            </label>
                            <input
                              type="text"
                              name="email_personnel"
                              v-model="vacataire.email_personnel"
                              class="form-control"
                              :class="{
                                'is-invalid': errors.email_personnel,
                              }"
                            />
                            <div
                              style="color: red"
                              v-if="errors.email_personnel"
                            >
                              {{ errors.email_personnel[0] }}
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <label
                              >EMAIL UIR<span
                                v-if="
                                  vacataire.personnel == null &&
                                  vacataire.email_uir
                                "
                                style="color: #ee2d41"
                                >*</span
                              ></label
                            >
                            <input
                              type="text"
                              name="email_uir"
                              v-model="vacataire.email_uir"
                              class="form-control"
                              disabled
                              placeholder="EMAIL UIR"
                            />
                          </div>
                          <div class="col-lg-4">
                            <label
                              >PROFESSION<span style="color: #ee2d41"
                                >*</span
                              ></label
                            >
                            <input
                              type="text"
                              name="profession"
                              v-model.trim="$v.vacataire.profession.$model"
                              class="form-control"
                              :class="{
                                'is-invalid': errors.profession,
                              }"
                            />
                            <div style="color: red" v-if="errors.profession">
                              {{ errors.profession[0] }}
                            </div>
                          </div>
                        </div>
                        <div class="form-group row">
                          <div class="col-lg-6">
                            <label>
                              DERNIER DIPLÔME<span style="color: #ee2d41"
                                >*</span
                              >
                            </label>
                            <input
                              type="text"
                              name="dernier_diplome"
                              v-model.trim="vacataire.dernier_diplome"
                              class="form-control"
                              :class="{
                                'is-invalid': errors.dernier_diplome,
                              }"
                            />
                            <div
                              style="color: red"
                              v-if="errors.dernier_diplome"
                            >
                              {{ errors.dernier_diplome[0] }}
                            </div>
                          </div>
                          <div class="col-lg-6" id="etablissement_origine">
                            <label>ÉTABLISSEMENT D'ORIGINE</label>
                            <input
                              type="text"
                              name="etablissement_dorigine"
                              v-model="vacataire.etablissement_dorigine"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="form-group row">
                          <div class="col-lg-6">
                            <label
                              >Secteur<span style="color: #ee2d41"
                                >*</span
                              ></label
                            >
                            <div class="radio-inline">
                              <label class="radio radio-outline radio-success">
                                <input
                                  class="public"
                                  type="radio"
                                  name="public"
                                  :value="1"
                                  v-model.trim="vacataire.public"
                                  :class="{
                                    'is-invalid': errors.public,
                                  }"
                                />

                                <span></span>Public
                              </label>
                              <label class="radio radio-outline radio-success">
                                <input
                                  class="public"
                                  type="radio"
                                  name="public"
                                  :value="0"
                                  v-model="vacataire.public"
                                  :class="{
                                    'is-invalid': errors.public,
                                  }"
                                />

                                <span></span>Privé
                              </label>
                            </div>
                            <div style="color: red" v-if="errors.public">
                              {{ errors.public[0] }}
                            </div>
                          </div>
                          <div class="col-lg-6" id="engager">
                            <label
                              >Ministère de Tutelle<span style="color: #ee2d41"
                                >*</span
                              ></label
                            >
                            <div class="radio-inline">
                              <label class="radio radio-outline radio-success">
                                <input
                                  class="engager"
                                  type="radio"
                                  name="engager"
                                  :value="1"
                                  v-model="vacataire.engager"
                                  :class="{
                                    'is-invalid': errors.engager,
                                  }"
                                />
                                <span></span>Ministère de l'Enseignement
                                Supérieur (MES)
                              </label>
                              <label class="radio radio-outline radio-success">
                                <input
                                  class="engager"
                                  type="radio"
                                  name="engager"
                                  :value="0"
                                  v-model="vacataire.engager"
                                  :class="{
                                    'is-invalid': errors.engager,
                                  }"
                                />

                                <span></span>Autre
                              </label>
                            </div>
                            <div style="color: red" v-if="errors.engager">
                              {{ errors.engager[0] }}
                            </div>
                          </div>
                          <div class="col-lg-6 mt-5">
                            <fieldset class="scheduler-border">
                              <legend class="scheduler-border">
                                Régime d'affiliation
                              </legend>
                              <div class="control-group">
                                <select
                                  name="regime_affiliation"
                                  class="selectpicker mb-3"
                                  data-width="100%"
                                  v-model="regime_affiliation"
                                  :class="{
                                    'is-invalid': errors.regime_affiliation,
                                  }"
                                >
                                  <option
                                    :selected="
                                      vacataire.regime_affiliation == 'CMR'
                                    "
                                    value="CMR"
                                  >
                                    CMR
                                  </option>
                                  <option
                                    :selected="
                                      'RCAR' == vacataire.regime_affiliation
                                    "
                                    value="RCAR"
                                  >
                                    RCAR
                                  </option>
                                  <option
                                    :selected="
                                      'CNSS' == vacataire.regime_affiliation
                                    "
                                    value="CNSS"
                                  >
                                    CNSS
                                  </option>
                                  <option
                                    :selected="
                                      'Auto-Entrepreneur' ==
                                      vacataire.regime_affiliation
                                    "
                                    value="Auto-Entrepreneur"
                                  >
                                    Auto-Entrepreneur
                                  </option>
                                  <option
                                    :selected="
                                      'Autre' == vacataire.regime_affiliation
                                    "
                                    value="Autre"
                                  >
                                    Autre
                                  </option>
                                </select>
                                <div v-if="regime_affiliation == 'CMR'">
                                  <label>
                                    Numéro PPR (NO de SOM)<span
                                      style="color: #ee2d41"
                                      >*</span
                                    >
                                  </label>
                                  <input
                                    type="text"
                                    name="code_regime_affiliation"
                                    v-model.trim="code_regime_affiliation"
                                    class="form-control"
                                    :class="{
                                      'is-invalid':
                                        errors.code_regime_affiliation,
                                    }"
                                  />
                                  <label class="mt-3">
                                    Attestation de travail récente
                                    <span style="color: #ee2d41">*</span>
                                  </label>
                                  <a
                                    v-if="
                                      vacataire.current_step != 1 &&
                                      vacataire.regime_affiliation_file != null
                                    "
                                    @click.prevent="
                                      downloadRegimeAffiliation(vacataire.id)
                                    "
                                    class="btn btn-icon ml-3 btn-sm raduis-50 yes-icon-cercle"
                                  >
                                    <i class="icon-xl la la-check"></i>
                                  </a>
                                  <button
                                    v-if="
                                      vacataire.current_step != 1 &&
                                      vacataire.regime_affiliation_file != null
                                    "
                                    class="btn btn-link"
                                    @click.prevent="
                                      downloadRegimeAffiliation(vacataire.id)
                                    "
                                  >
                                    Télécharger
                                  </button>
                                </div>
                                <div v-if="regime_affiliation == 'RCAR'">
                                  <label>
                                    Numéro RCAR<span style="color: #ee2d41"
                                      >*</span
                                    >
                                  </label>
                                  <input
                                    type="text"
                                    name="code_regime_affiliation"
                                    v-model.trim="code_regime_affiliation"
                                    class="form-control"
                                    :class="{
                                      'is-invalid':
                                        errors.code_regime_affiliation,
                                    }"
                                  />
                                  <label class="mt-3">
                                    Attestation de travail récente
                                    <span style="color: #ee2d41">*</span>
                                  </label>
                                  <a
                                    v-if="
                                      vacataire.current_step != 1 &&
                                      vacataire.regime_affiliation_file != null
                                    "
                                    @click.prevent="
                                      downloadRegimeAffiliation(vacataire.id)
                                    "
                                    class="btn btn-icon ml-3 btn-sm raduis-50 yes-icon-cercle"
                                  >
                                    <i class="icon-xl la la-check"></i>
                                  </a>
                                  <button
                                    v-if="
                                      vacataire.current_step != 1 &&
                                      vacataire.regime_affiliation_file != null
                                    "
                                    class="btn btn-link"
                                    @click.prevent="
                                      downloadRegimeAffiliation(vacataire.id)
                                    "
                                  >
                                    Télécharger
                                  </button>
                                </div>
                                <div v-if="regime_affiliation == 'CNSS'">
                                  <label>
                                    Numéro CNSS<span style="color: #ee2d41"
                                      >*</span
                                    >
                                  </label>
                                  <input
                                    type="text"
                                    name="code_regime_affiliation"
                                    v-model.trim="code_regime_affiliation"
                                    class="form-control"
                                    :class="{
                                      'is-invalid':
                                        errors.code_regime_affiliation,
                                    }"
                                  />
                                </div>
                                <div
                                  v-if="
                                    regime_affiliation == 'Auto-Entrepreneur'
                                  "
                                >
                                  <label>
                                    Numéro d'lmmatriculation au Registre
                                    National des Auto-Entrepreneurs (RNAE)<span
                                      style="color: #ee2d41"
                                      >*</span
                                    >
                                  </label>
                                  <input
                                    type="text"
                                    name="code_regime_affiliation"
                                    v-model.trim="code_regime_affiliation"
                                    class="form-control"
                                    :class="{
                                      'is-invalid':
                                        errors.code_regime_affiliation,
                                    }"
                                  />
                                </div>
                                <div
                                  style="color: red"
                                  v-if="regime_affiliation == 'Autre'"
                                >
                                  <label>
                                    Votre régime d'affiliation<span
                                      style="color: #ee2d41"
                                      >*</span
                                    >
                                  </label>

                                  <input
                                    type="text"
                                    name="code_regime_affiliation"
                                    v-model.trim="code_regime_affiliation"
                                    class="form-control"
                                    :class="{
                                      'is-invalid':
                                        errors.code_regime_affiliation,
                                    }"
                                  />
                                </div>
                              </div>
                              <div
                                style="color: red"
                                v-if="errors.code_regime_affiliation"
                              >
                                {{ errors.code_regime_affiliation[0] }}
                              </div>
                            </fieldset>
                          </div>
                        </div>
                        <div class="d-flex justify-content-center">
                          <button v-show="role && role.nom === 'SUPERADMIN'"
                            type="button"
                            @click="updateVacataire()"
                            class="submit-btn pl-12 pr-12 btn btn-lg"
                          >
                            <i class="fas fa-check"></i> ENREGISTRER
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <!--end: Wizard Step 1-->

                  <!--begin: Wizard Step 2-->
                  <div
                    id="content_step_2"
                    class="pb-5"
                    data-wizard-type="step-content"
                    :data-wizard-state="
                      current_step == 2
                        ? 'current'
                        : current_step > 2
                        ? 'done'
                        : 'pending'
                    "
                  >
                    <div class="card-body">
                      <form method="POST" enctype="multipart/form-data">
                        <div class="form-group row d-flex align-items-center">
                          <div class="col-md-5">
                            <div class="attestations-files">
                              <div class="card-body text-center">
                                <h5 class="card-title">
                                  Attestation de RIB<span style="color: #ee2d41"
                                    >*</span
                                  >
                                </h5>
                                <div class="attestation-file">
                                  <div
                                    class="image-input image-input-outline"
                                    id="kt_image_1"
                                  >
                                    <img
                                      class="image-input-wrapper"
                                      :src="getAttestationRIB()"
                                      style="width: 260px; height: 260px"
                                      id="oldImage"
                                    />
                                    <img
                                      class="image-input-wrapper"
                                      :src="imagePreview"
                                      id="newAttestationRib"
                                      :style="{
                                        display: showAttestationRIB
                                          ? 'block'
                                          : 'none',
                                      }"
                                      style="width: 260px; height: 260px"
                                    />
                                    <label
                                      class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                      data-action="change"
                                      data-toggle="tooltip"
                                      title=""
                                      data-original-title="Changer attestation RIB"
                                    >
                                      <i
                                        class="fa fa-pen icon-sm text-muted"
                                      ></i>
                                      <input
                                        type="file"
                                        name="attestation_rib"
                                        @change="onImageChange"
                                        accept=".png, .jpg, .jpeg"
                                      />
                                    </label>
                                    <span
                                      style="color: #ee2d41; display: none"
                                      id="attestation_rib_error"
                                    >
                                      l'attestation de RIB est obligatoire
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-7">
                            <div class="row mb-4">
                              <div class="col-lg-6">
                                <label>
                                  NOM BANQUE<span style="color: #ee2d41"
                                    >*</span
                                  >
                                </label>
                                <select
                                  name="banque"
                                  v-model="vacataire.banque"
                                  :class="{
                                    'is-invalid': errors.banque,
                                  }"
                                  class="selectpicker"
                                  data-width="100%"
                                  data-live-search="true"
                                >
                                  <option
                                    :selected="
                                      'ARAB BANK MAROC' == vacataire.banque
                                    "
                                    value="ARAB BANK MAROC"
                                  >
                                    ARAB BANK MAROC
                                  </option>
                                  <option
                                    :selected="'Umnia bank' == vacataire.banque"
                                    value="Umnia bank"
                                  >
                                    Umnia bank
                                  </option>
                                  <option
                                    :selected="
                                      'ATTIJARIWAFA BANK' == vacataire.banque
                                    "
                                    value="ATTIJARIWAFA BANK"
                                  >
                                    ATTIJARIWAFA BANK
                                  </option>
                                  <option
                                    :selected="
                                      'AL BARID BANK' == vacataire.banque
                                    "
                                    value="AL BARID BANK"
                                  >
                                    AL BARID BANK
                                  </option>
                                  <option
                                    :selected="
                                      'BANQUE CENTRALE POPULAIRE' ==
                                      vacataire.banque
                                    "
                                    value="BANQUE CENTRALE POPULAIRE"
                                  >
                                    BANQUE CENTRALE POPULAIRE
                                  </option>
                                  <option
                                    :selected="
                                      'BANK OF AFRICA' == vacataire.banque
                                    "
                                    value="BANK OF AFRICA"
                                  >
                                    BANK OF AFRICA
                                  </option>
                                  <option
                                    :selected="'BMCI' == vacataire.banque"
                                    value="BMCI"
                                  >
                                    BMCI
                                  </option>
                                  <option
                                    :selected="'BMCE' == vacataire.banque"
                                    value="BMCE"
                                  >
                                    BMCE
                                  </option>
                                  <option
                                    :selected="'CAIXA BANK' == vacataire.banque"
                                    value="CAIXA BANK"
                                  >
                                    CAIXA BANK
                                  </option>
                                  <option
                                    :selected="
                                      'CREDIT AGRICOLE DU MAROC' ==
                                      vacataire.banque
                                    "
                                    value="CREDIT AGRICOLE DU MAROC"
                                  >
                                    CREDIT AGRICOLE DU MAROC
                                  </option>
                                  <option
                                    :selected="'CFG BANK' == vacataire.banque"
                                    value="CFG BANK"
                                  >
                                    CFG BANK
                                  </option>
                                  <option
                                    :selected="
                                      'CDG CAPITAL' == vacataire.banque
                                    "
                                    value="CDG CAPITAL"
                                  >
                                    CDG CAPITAL
                                  </option>
                                  <option
                                    :selected="'CIH' == vacataire.banque"
                                    value="CIH"
                                  >
                                    CIH
                                  </option>
                                  <option
                                    :selected="
                                      'CITIBANK MAGHREB' == vacataire.banque
                                    "
                                    value="CITIBANK MAGHREB"
                                  >
                                    CITIBANK MAGHREB
                                  </option>
                                  <option
                                    :selected="
                                      'CREDIT DU MAROC' == vacataire.banque
                                    "
                                    value="CREDIT DU MAROC"
                                  >
                                    CREDIT DU MAROC
                                  </option>
                                  <option
                                    :selected="'SABADEL' == vacataire.banque"
                                    value="SABADEL"
                                  >
                                    SABADEL
                                  </option>
                                  <option
                                    :selected="
                                      'SOCIETE GENERALE MAROCAINE DE BANQUES' ==
                                      vacataire.banque
                                    "
                                    value="SOCIETE GENERALE MAROCAINE DE BANQUES"
                                  >
                                    SOCIETE GENERALE MAROCAINE DE BANQUES
                                  </option>
                                  <option
                                    :selected="
                                      'UNION MAROCAINE DES BANQUES' ==
                                      vacataire.banque
                                    "
                                    value="UNION MAROCAINE DES BANQUES"
                                  >
                                    UNION MAROCAINE DES BANQUES
                                  </option>
                                  <option
                                    :selected="
                                      'Bank Assafa' == vacataire.banque
                                    "
                                    value="Bank Assafa"
                                  >
                                    Bank Assafa
                                  </option>
                                  <option
                                    :selected="
                                      'Bank al yousr' == vacataire.banque
                                    "
                                    value="Bank al yousr"
                                  >
                                    Bank al yousr
                                  </option>
                                  <option
                                    :selected="'Autre' == vacataire.banque"
                                    value="Autre"
                                  >
                                    Autre
                                  </option>
                                </select>
                                <div style="color: red" v-if="errors.banque">
                                  {{ errors.banque[0] }}
                                </div>
                              </div>
                              <div class="col-lg-6">
                                <label
                                  >RIB<span style="color: #ee2d41"
                                    >*</span
                                  ></label
                                >
                                <input
                                  type="text"
                                  name="rib"
                                  v-model="vacataire.rib"
                                  :class="{
                                    'is-invalid': errors.rib,
                                  }"
                                  class="form-control"
                                />
                                <span style="color: #ee2d41" v-if="errors.rib">
                                  <span> {{ errors.rib[0] }} </span>
                                  <span> {{ errors.rib[1] }} </span>
                                  <span> {{ errors.rib[2] }} </span>
                                </span>
                              </div>
                            </div>

                            <div class="form-group row">
                              <div class="col-lg-6">
                                <label>SWIFT</label>
                                <input
                                  type="text"
                                  name="swift"
                                  v-model="vacataire.swift"
                                  class="form-control"
                                />
                              </div>
                              <div class="col-lg-6">
                                <label>IBAN</label>
                                <input
                                  type="text"
                                  name="iban"
                                  v-model="vacataire.iban"
                                  class="form-control"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex justify-content-center">
                          <button v-show="role && role.nom === 'SUPERADMIN'"
                            type="button"
                            @click="updateBanqueInfo()"
                            class="submit-btn pl-12 pr-12 btn btn-lg"
                          >
                            <i class="fas fa-check"></i> ENREGISTRER
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <!--end: Wizard Step 2-->

                  <!--begin: Wizard Step 3-->
                  <div
                    id="content_step_3"
                    :data-wizard-state="
                      current_step == 3
                        ? 'current'
                        : current_step > 3
                        ? 'done'
                        : 'pending'
                    "
                    class="pb-5"
                    data-wizard-type="step-content"
                  >
                    <div>
                      <form method="POST" enctype="multipart/form-data">
                        <div class="row">
                          <div class="attestations-files col-md-6">
                            <div class="card-body text-center">
                              <h5 class="card-title">
                                CV<span style="color: #ee2d41">*</span>
                              </h5>
                              <div class="attestation-file mb-5">
                                <div
                                  class="image-input image-input-outline"
                                  id="kt_image_1"
                                >
                                  <img
                                    v-if="!getCV()"
                                    class="image-input-wrapper"
                                    src="/images/document.png"
                                    style="width: 260px; height: 260px"
                                    id="oldCV"
                                  />
                                  <img
                                    v-if="
                                      getCV() &&
                                      (getCV().path.includes('png') ||
                                        getCV().path.includes('jpe') ||
                                        getCV().path.includes('jpeg') ||
                                        getCV().path.includes('jpg'))
                                    "
                                    class="image-input-wrapper"
                                    :src="'/' + getCV().path"
                                    style="width: 260px; height: 260px"
                                    id="oldCV"
                                  />
                                  <object
                                    v-if="
                                      getCV() && getCV().path.includes('pdf')
                                    "
                                    :data="'/' + getCV().path"
                                    type="application/pdf"
                                    style="min-height: 260px; width: 260px"
                                    id="oldCVpdf"
                                  >
                                    <embed
                                      :src="'/' + getCV().path"
                                      type="application/pdf"
                                    />
                                  </object>
                                  <img
                                    v-show="
                                      cv &&
                                      (cv.type == 'image/png' ||
                                        cv.type == 'image/jpe' ||
                                        cv.type == 'image/jpeg' ||
                                        cv.type == 'image/jpg')
                                    "
                                    class="image-input-wrapper"
                                    :src="cvPreview"
                                    style="width: 260px; height: 260px"
                                  />
                                  <object
                                    v-show="cv && cv.type == 'application/pdf'"
                                    :data="cvPreview"
                                    type="application/pdf"
                                    style="min-height: 260px; width: 260px"
                                  >
                                    <embed
                                      :src="cvPreview"
                                      type="application/pdf"
                                    />
                                  </object>
                                  <label
                                    class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                    data-action="change"
                                    data-toggle="tooltip"
                                    title=""
                                    data-original-title="Changer CV"
                                  >
                                    <i class="fa fa-pen icon-sm text-muted"></i>
                                    <input
                                      type="file"
                                      name="photo"
                                      @change="onCVChange"
                                      accept=".pdf"
                                    />
                                  </label>
                                </div>
                              </div>
                              <span
                                style="color: #ee2d41; display: block"
                                id="cv_error"
                              >
                                le CV est obligatoire
                              </span>
                            </div>
                          </div>

                          <div class="attestations-files col-md-6">
                            <div class="card-body text-center">
                              <h5 class="card-title">
                                Diplome<span style="color: #ee2d41">*</span>
                              </h5>
                              <div class="attestation-file mb-5">
                                <div
                                  class="image-input image-input-outline"
                                  id="kt_image_1"
                                >
                                  <img
                                    v-if="!getDiplome()"
                                    class="image-input-wrapper"
                                    src="/images/document.png"
                                    style="width: 260px; height: 260px"
                                    id="oldDiplome"
                                  />
                                  <img
                                    v-if="
                                      getDiplome() &&
                                      (getDiplome().path.includes('png') ||
                                        getDiplome().path.includes('jpe') ||
                                        getDiplome().path.includes('jpeg') ||
                                        getDiplome().path.includes('jpg'))
                                    "
                                    class="image-input-wrapper"
                                    :src="'/' + getDiplome().path"
                                    style="width: 260px; height: 260px"
                                    id="oldDiplome"
                                  />
                                  <object
                                    v-if="
                                      getDiplome() &&
                                      getDiplome().path.includes('pdf')
                                    "
                                    :data="'/' + getDiplome().path"
                                    type="application/pdf"
                                    style="min-height: 260px; width: 260px"
                                    id="oldDiplomepdf"
                                  >
                                    <embed
                                      :src="'/' + getDiplome().path"
                                      type="application/pdf"
                                    />
                                  </object>
                                  <img
                                    v-show="
                                      diplome &&
                                      (diplome.type == 'image/png' ||
                                        diplome.type == 'image/jpe' ||
                                        diplome.type == 'image/jpeg' ||
                                        diplome.type == 'image/jpg')
                                    "
                                    class="image-input-wrapper"
                                    :src="DiplomePreview"
                                    style="width: 260px; height: 260px"
                                  />
                                  <object
                                    v-show="
                                      diplome &&
                                      diplome.type == 'application/pdf'
                                    "
                                    :data="DiplomePreview"
                                    type="application/pdf"
                                    style="min-height: 260px; width: 260px"
                                  >
                                    <embed
                                      :src="DiplomePreview"
                                      type="application/pdf"
                                    />
                                  </object>
                                  <label
                                    class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                    data-action="change"
                                    data-toggle="tooltip"
                                    title=""
                                    data-original-title="Changer diplome"
                                  >
                                    <i class="fa fa-pen icon-sm text-muted"></i>
                                    <input
                                      type="file"
                                      name="photo"
                                      @change="onDiplomeChange"
                                      accept=".png, .jpg, .jpeg"
                                    />
                                  </label>
                                </div>
                              </div>
                              <span
                                style="color: #ee2d41; display: none"
                                id="diplome_error"
                              >
                                le diplome est obligatoire
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="attestations-files col-md-4">
                            <div class="card-body text-center">
                              <h5 class="card-title">
                                CIN RECTO<span style="color: #ee2d41">*</span>
                              </h5>
                              <div class="attestation-file mb-5">
                                <div
                                  class="image-input image-input-outline"
                                  id="kt_image_1"
                                >
                                  <img
                                    v-if="!getCIN()"
                                    class="image-input-wrapper"
                                    src="/images/document.png"
                                    style="width: 260px; height: 260px"
                                    id="oldCIN"
                                  />
                                  <img
                                    v-if="
                                      getCIN() &&
                                      (getCIN().path.includes('png') ||
                                        getCIN().path.includes('jpe') ||
                                        getCIN().path.includes('jpeg') ||
                                        getCIN().path.includes('jpg'))
                                    "
                                    class="image-input-wrapper"
                                    :src="'/' + getCIN().path"
                                    style="width: 260px; height: 260px"
                                    id="oldCIN"
                                  />
                                  <object
                                    v-if="
                                      getCIN() && getCIN().path.includes('pdf')
                                    "
                                    :data="'/' + getCIN().path"
                                    type="application/pdf"
                                    style="min-height: 260px; width: 260px"
                                    id="oldCINpdf"
                                  >
                                    <embed
                                      :src="'/' + getCIN().path"
                                      type="application/pdf"
                                    />
                                  </object>
                                  <img
                                    v-show="
                                      cin &&
                                      (cin.type == 'image/png' ||
                                        cin.type == 'image/jpe' ||
                                        cin.type == 'image/jpeg' ||
                                        cin.type == 'image/jpg')
                                    "
                                    class="image-input-wrapper"
                                    :src="cinPreview"
                                    style="width: 260px; height: 260px"
                                  />
                                  <object
                                    v-show="
                                      cin && cin.type == 'application/pdf'
                                    "
                                    :data="cinPreview"
                                    type="application/pdf"
                                    style="min-height: 260px; width: 260px"
                                  >
                                    <embed
                                      :src="cinPreview"
                                      type="application/pdf"
                                    />
                                  </object>
                                  <label
                                    class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                    data-action="change"
                                    data-toggle="tooltip"
                                    title=""
                                    data-original-title="Changer CIN"
                                  >
                                    <i class="fa fa-pen icon-sm text-muted"></i>
                                    <input
                                      type="file"
                                      name="photo"
                                      @change="onCINChange"
                                      accept=".png, .jpg, .jpeg"
                                    />
                                  </label>
                                </div>
                              </div>
                              <span
                                style="color: #ee2d41; display: none"
                                id="cin_error"
                              >
                                la CIN est obligatoire
                              </span>
                            </div>
                          </div>

                          <div class="attestations-files col-md-4">
                            <div class="card-body text-center">
                              <h5 class="card-title">
                                CIN VERSO<span style="color: #ee2d41">*</span>
                              </h5>
                              <div class="attestation-file mb-5">
                                <div
                                  class="image-input image-input-outline"
                                  id="kt_image_1"
                                >
                                  <img
                                    v-if="!getCIN2()"
                                    class="image-input-wrapper"
                                    src="/images/document.png"
                                    style="width: 260px; height: 260px"
                                    id="oldCIN2"
                                  />
                                  <img
                                    v-if="
                                      getCIN2() &&
                                      (getCIN2().path.includes('png') ||
                                        getCIN2().path.includes('jpe') ||
                                        getCIN2().path.includes('jpeg') ||
                                        getCIN2().path.includes('jpg'))
                                    "
                                    class="image-input-wrapper"
                                    :src="'/' + getCIN2().path"
                                    style="width: 260px; height: 260px"
                                    id="oldCIN2"
                                  />
                                  <object
                                    v-if="
                                      getCIN2() && getCIN2().path.includes('pdf')
                                    "
                                    :data="'/' + getCIN2().path"
                                    type="application/pdf"
                                    style="min-height: 260px; width: 260px"
                                    id="oldCIN2pdf"
                                  >
                                    <embed
                                      :src="'/' + getCIN2().path"
                                      type="application/pdf"
                                    />
                                  </object>
                                  <img
                                    v-show="
                                      cin2 &&
                                      (cin2.type == 'image/png' ||
                                        cin2.type == 'image/jpe' ||
                                        cin2.type == 'image/jpeg' ||
                                        cin2.type == 'image/jpg')
                                    "
                                    class="image-input-wrapper"
                                    :src="cin2Preview"
                                    style="width: 260px; height: 260px"
                                  />
                                  <object
                                    v-show="
                                      cin2 && cin2.type == 'application/pdf'
                                    "
                                    :data="cin2Preview"
                                    type="application/pdf"
                                    style="min-height: 260px; width: 260px"
                                  >
                                    <embed
                                      :src="cin2Preview"
                                      type="application/pdf"
                                    />
                                  </object>
                                  <label
                                    class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                    data-action="change"
                                    data-toggle="tooltip"
                                    title=""
                                    data-original-title="Changer CIN"
                                  >
                                    <i class="fa fa-pen icon-sm text-muted"></i>
                                    <input
                                      type="file"
                                      name="photo"
                                      @change="onCIN2Change"
                                      accept=".png, .jpg, .jpeg"
                                    />
                                  </label>
                                </div>
                              </div>
                              <span
                                style="color: #ee2d41; display: none"
                                id="cin2_error"
                              >
                                la CIN est obligatoire
                              </span>
                            </div>
                          </div>

                          <div class="attestations-files col-md-4">
                            <div class="card-body text-center">
                              <h5 class="card-title">
                                Autorisation<span style="color: #ee2d41"
                                  >*</span
                                >
                              </h5>
                              <div class="attestation-file mb-5">
                                <div
                                  class="image-input image-input-outline"
                                  id="kt_image_1"
                                >
                                  <img
                                    v-if="!getAutorisation()"
                                    class="image-input-wrapper"
                                    src="/images/document.png"
                                    style="width: 260px; height: 260px"
                                    id="oldAutorisation"
                                  />
                                  <img
                                    v-if="
                                      getAutorisation() &&
                                      (getAutorisation().path.includes('png') ||
                                        getAutorisation().path.includes(
                                          'jpe'
                                        ) ||
                                        getAutorisation().path.includes(
                                          'jpeg'
                                        ) ||
                                        getAutorisation().path.includes('jpg'))
                                    "
                                    class="image-input-wrapper"
                                    :src="'/' + getAutorisation().path"
                                    style="width: 260px; height: 260px"
                                    id="oldAutorisation"
                                  />
                                  <object
                                    v-if="
                                      getAutorisation() &&
                                      getAutorisation().path.includes('pdf')
                                    "
                                    :data="'/' + getAutorisation().path"
                                    type="application/pdf"
                                    style="min-height: 260px; width: 260px"
                                    id="oldAutorisationpdf"
                                  >
                                    <embed
                                      :src="'/' + getAutorisation().path"
                                      type="application/pdf"
                                    />
                                  </object>
                                  <img
                                    v-show="
                                      autorisation &&
                                      (autorisation.type == 'image/png' ||
                                        autorisation.type == 'image/jpe' ||
                                        autorisation.type == 'image/jpeg' ||
                                        autorisation.type == 'image/jpg')
                                    "
                                    class="image-input-wrapper"
                                    :src="autorisationPreview"
                                    style="width: 260px; height: 260px"
                                  />
                                  <object
                                    v-show="
                                      autorisation &&
                                      autorisation.type == 'application/pdf'
                                    "
                                    :data="autorisationPreview"
                                    type="application/pdf"
                                    style="min-height: 260px; width: 260px"
                                  >
                                    <embed
                                      :src="autorisationPreview"
                                      type="application/pdf"
                                    />
                                  </object>
                                  <label
                                    class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                    data-action="change"
                                    data-toggle="tooltip"
                                    title=""
                                    data-original-title="Changer autorisation"
                                  >
                                    <i class="fa fa-pen icon-sm text-muted"></i>
                                    <input
                                      type="file"
                                      name="photo"
                                      @change="onAutorisationChange"
                                      accept=".png, .jpg, .jpeg"
                                    />
                                  </label>
                                </div>
                              </div>
                              <span
                                style="color: #ee2d41; display: none"
                                id="autorisation_error"
                              >
                                la Autorisation est obligatoire
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex justify-content-center">
                          <div class="attestations-files col-md-6">
                            <div class="card-body text-center">
                              <h5 class="card-title">Autre</h5>
                              <div class="attestation-file mb-5">
                                <div
                                  class="image-input image-input-outline"
                                  id="kt_image_1"
                                >
                                  <img
                                    v-if="!getAutre()"
                                    class="image-input-wrapper"
                                    src="/images/document.png"
                                    style="width: 260px; height: 260px"
                                    id="oldAutre"
                                  />
                                  <img
                                    v-if="
                                      getAutre() &&
                                      (getAutre().path.includes('png') ||
                                        getAutre().path.includes('jpe') ||
                                        getAutre().path.includes('jpeg') ||
                                        getAutre().path.includes('jpg'))
                                    "
                                    class="image-input-wrapper"
                                    :src="'/' + getAutre().path"
                                    style="width: 260px; height: 260px"
                                    id="oldAutre"
                                  />
                                  <object
                                    v-if="
                                      getAutre() &&
                                      getAutre().path.includes('pdf')
                                    "
                                    :data="'/' + getAutre().path"
                                    type="application/pdf"
                                    style="min-height: 260px; width: 260px"
                                    id="oldAutrepdf"
                                  >
                                    <embed
                                      :src="'/' + getAutre().path"
                                      type="application/pdf"
                                    />
                                  </object>
                                  <img
                                    v-show="
                                      Autre &&
                                      (Autre.type == 'image/png' ||
                                        Autre.type == 'image/jpe' ||
                                        Autre.type == 'image/jpeg' ||
                                        Autre.type == 'image/jpg')
                                    "
                                    class="image-input-wrapper"
                                    :src="AutrePreview"
                                    style="width: 260px; height: 260px"
                                  />
                                  <object
                                    v-show="
                                      Autre && Autre.type == 'application/pdf'
                                    "
                                    :data="AutrePreview"
                                    type="application/pdf"
                                    style="min-height: 260px; width: 260px"
                                  >
                                    <embed
                                      :src="AutrePreview"
                                      type="application/pdf"
                                    />
                                  </object>
                                  <label
                                    class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                    data-action="change"
                                    data-toggle="tooltip"
                                    title=""
                                    data-original-title="Changer le fichier"
                                  >
                                    <i class="fa fa-pen icon-sm text-muted"></i>
                                    <input
                                      type="file"
                                      name="photo"
                                      @change="onAutreChange"
                                      accept=".png, .jpg, .jpeg"
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="attestations-files col-md-6">
                            <div class="card-body text-center">
                              <h5 class="card-title">Passeport</h5>
                              <div class="attestation-file mb-5">
                                <div
                                  class="image-input image-input-outline"
                                  id="kt_image_1"
                                >
                                  <img
                                    v-if="!getPasseport()"
                                    class="image-input-wrapper"
                                    src="/images/document.png"
                                    style="width: 260px; height: 260px"
                                    id="oldPasseport"
                                  />
                                  <img
                                    v-if="
                                      getPasseport() &&
                                      (getPasseport().path.includes('png') ||
                                        getPasseport().path.includes('jpe') ||
                                        getPasseport().path.includes('jpeg') ||
                                        getPasseport().path.includes('jpg'))
                                    "
                                    class="image-input-wrapper"
                                    :src="'/' + getPasseport().path"
                                    style="width: 260px; height: 260px"
                                    id="oldPasseport"
                                  />
                                  <object
                                    v-if="
                                      getPasseport() &&
                                      getPasseport().path.includes('pdf')
                                    "
                                    :data="'/' + getPasseport().path"
                                    type="application/pdf"
                                    style="min-height: 260px; width: 260px"
                                    id="oldPasseportpdf"
                                  >
                                    <embed
                                      :src="'/' + getPasseport().path"
                                      type="application/pdf"
                                    />
                                  </object>
                                  <img
                                    v-show="
                                      Passeport &&
                                      (Passeport.type == 'image/png' ||
                                        Passeport.type == 'image/jpe' ||
                                        Passeport.type == 'image/jpeg' ||
                                        Passeport.type == 'image/jpg')
                                    "
                                    class="image-input-wrapper"
                                    :src="PasseportPreview"
                                    style="width: 260px; height: 260px"
                                  />
                                  <object
                                    v-show="
                                      Passeport && Passeport.type == 'application/pdf'
                                    "
                                    :data="PasseportPreview"
                                    type="application/pdf"
                                    style="min-height: 260px; width: 260px"
                                  >
                                    <embed
                                      :src="PasseportPreview"
                                      type="application/pdf"
                                    />
                                  </object>
                                  <label
                                    class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                    data-action="change"
                                    data-toggle="tooltip"
                                    title=""
                                    data-original-title="Changer le fichier"
                                  >
                                    <i class="fa fa-pen icon-sm text-muted"></i>
                                    <input
                                      type="file"
                                      name="photo"
                                      @change="onPasseportChange"
                                      accept=".png, .jpg, .jpeg"
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="d-flex justify-content-center">
                          <button v-show="role && role.nom === 'SUPERADMIN'"
                            type="button"
                            @click="updateDossier()"
                            id="enregistrer"
                            class="submit-btn pl-12 pr-12 btn btn-lg"
                          >
                            <i class="fas fa-check"></i> ENREGISTRER
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <!--end: Wizard Step 3-->

                  <!--begin: Wizard Actions-->
                  <div
                    class="d-flex justify-content-between border-top mt-5 pt-10"
                  >
                    <div class="mr-2">
                      <button
                        type="button"
                        id="prev-step"
                        class="btn btn-light-primary font-weight-bolder px-10 py-3"
                        @click="previous_step()"
                        v-if="current_step != 1"
                      >
                        <span class="svg-icon svg-icon-md mr-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24"></polygon>
                              <rect
                                fill="#000000"
                                opacity="0.3"
                                transform="translate(12.000000, 12.000000) scale(-1, 1) rotate(-90.000000) translate(-12.000000, -12.000000) "
                                x="11"
                                y="5"
                                width="2"
                                height="14"
                                rx="1"
                              ></rect>
                              <path
                                d="M3.7071045,15.7071045 C3.3165802,16.0976288 2.68341522,16.0976288 2.29289093,15.7071045 C1.90236664,15.3165802 1.90236664,14.6834152 2.29289093,14.2928909 L8.29289093,8.29289093 C8.67146987,7.914312 9.28105631,7.90106637 9.67572234,8.26284357 L15.6757223,13.7628436 C16.0828413,14.136036 16.1103443,14.7686034 15.7371519,15.1757223 C15.3639594,15.5828413 14.7313921,15.6103443 14.3242731,15.2371519 L9.03007346,10.3841355 L3.7071045,15.7071045 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                                transform="translate(9.000001, 11.999997) scale(-1, -1) rotate(90.000000) translate(-9.000001, -11.999997) "
                              ></path>
                            </g>
                          </svg>
                        </span>
                        Previous
                      </button>
                    </div>
                    <div>
                      <button
                        type="button"
                        class="btn btn-success font-weight-bolder px-10 py-3"
                        data-wizard-type="action-submit"
                      >
                        Submit
                        <span class="svg-icon svg-icon-md ml-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24"></polygon>
                              <path
                                d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                                transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "
                              ></path>
                            </g>
                          </svg>
                        </span>
                      </button>

                      <button
                        type="button"
                        id="next-step"
                        class="btn btn-primary font-weight-bolder px-10 py-3"
                        data-wizard-type="action-next"
                        @click="next_step()"
                        v-if="current_step != 3"
                      >
                        Next
                        <span class="svg-icon svg-icon-md ml-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24"></polygon>
                              <rect
                                fill="#000000"
                                opacity="0.3"
                                transform="translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) "
                                x="11"
                                y="5"
                                width="2"
                                height="14"
                                rx="1"
                              ></rect>
                              <path
                                d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                                transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997) "
                              ></path>
                            </g>
                          </svg>
                        </span>
                      </button>
                    </div>
                  </div>
                  <!--end: Wizard Actions-->
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </form>
                <!--end: Wizard Form-->
              </div>
            </div>
            <!--end: Wizard Body-->
          </div>
          <!--end: Wizard-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import {
  required,
  requiredIf,
  email,
  minLength,
  maxLength,
  helpers,
} from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
  mixins: [validationMixin],
  components: {
    Datepicker,
  },
  props: {
    vacataire: {},
    pays: {},
    admin: {},
    role: {},
  },
  data() {
    return {
      //attestation RIB
      image: null,
      imagePreview: null,
      showAttestationRIB: false,

      //CV
      cv: null,
      cvPreview: null,

      //CIN
      cin: null,
      cinPreview: null,

      //CIN2
      cin2: null,
      cin2Preview: null,

      //Autorisation
      autorisation: null,
      autorisationPreview: null,

      //Autre
      Autre: null,
      AutrePreview: null,

      //Passeport
      Passeport: null,
      PasseportPreview: null,

      //Diplome
      diplome: null,
      DiplomePreview: null,

      //image profil
      imageProfil: null,
      imageProfilPreview: null,
      showProfil: false,

      //errors
      errors: {},

      regime_affiliation: null,
      regime_affiliation_file: null,
      code_regime_affiliation: null,

      current_step:
        this.vacataire.current_step != null ? this.vacataire.current_step : 1,
    };
  },
  validations() {
    return {
      vacataire: {
        cin: { required },
        cin2: { required },
        date_naissance: { required },
        pays_id: { required },
        adresse: { required },
        tel: { required },
        profession: { required },
        dernier_diplome: { required },
        engager: { required },
        public: { required },
        banque: { required },
        rib: { required, minLength: minLength(24), maxLength: maxLength(24) },
      },
      regime_affiliation: {
        required: requiredIf(function () {
          return this.vacataire.partenaire != 1;
        }),
      },
    };
  },
  watch: {
    rib(newImage, oldImage) {
      var x = document.getElementById("submit_image");
      if (newImage != "") {
        x.style.display = "block";
      }
    },
  },
  methods: {
    //stepper actions
    toggle_step(step) {
      this.current_step = step;
    },
    next_step() {
      // if the vacataire in the 1st steep validate the form and submit it
      if (this.role && this.role.nom == 'SUPERADMIN') {
        if (this.vacataire.current_step == 1) {
        this.updateVacataire();
        } else if (this.vacataire.current_step == 2) {
        this.updateBanqueInfo();
        } else if (this.vacataire.current_step > this.current_step) {
        this.current_step++;
        }
      } else {
        this.current_step++;
      }
    },
    previous_step() {
      this.current_step--;
    },
    //end stepper actions
    getProfilePhoto() {
      var photo =
        this.vacataire.image_path == null
          ? "/images/avatar.png"
          : "/" + this.vacataire.image_path;
      return photo;
    },

    getCV() {
      var cv = null;
      if (this.vacataire.documents.length > 0) {
        this.vacataire.documents.forEach((value) => {
          if (value.type === "CV") {
            cv = value;
          }
        });
      }

      return cv;
    },

    getCIN() {
      var cin = null;
      if (this.vacataire.documents.length > 0) {
        this.vacataire.documents.forEach((value) => {
          if (value.type === "CIN") {
            cin = value;
          }
        });
      }

      return cin;
    },

    getCIN2() {
      var cin2 = null;
      if (this.vacataire.documents.length > 0) {
        this.vacataire.documents.forEach((value) => {
          if (value.type === "CIN2") {
            cin2 = value;
          }
        });
      }

      return cin2;
    },

    getAutorisation() {
      var autorisation = null;
      if (this.vacataire.documents.length > 0) {
        this.vacataire.documents.forEach((value) => {
          if (value.type === "Autorisation") {
            autorisation = value;
          }
        });
      }

      return autorisation;
    },

    getDiplome() {
      var Diplome = null;
      if (this.vacataire.documents.length > 0) {
        this.vacataire.documents.forEach((value) => {
          if (value.type === "Diplome") {
            Diplome = value;
          }
        });
      }

      return Diplome;
    },
    getAutre() {
      var Autre = null;
      if (this.vacataire.documents.length > 0) {
        this.vacataire.documents.forEach((value) => {
          if (value.type === "Autre") {
            Autre = value;
          }
        });
      }

      return Autre;
    },

    getPasseport() {
      var Passeport = null;
      if (this.vacataire.documents.length > 0) {
        this.vacataire.documents.forEach((value) => {
          if (value.type === "Passeport") {
            Passeport = value;
          }
        });
      }

      return Passeport;
    },

    getAttestationRIB() {
      var photo =
        this.vacataire.attestation_rib_path == null
          ? "/images/document.png"
          : "/" + this.vacataire.attestation_rib_path;

      return photo;
    },

    onImageChange(e) {
      this.image = e.target.files[0];
      console.log(this.image);
      let reader = new FileReader();
      reader.readAsDataURL(this.image);
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };

      var old = document.getElementById("oldImage");
      old.style.display = "none";

      /* var newAttestationRib = document.getElementById("newAttestationRib");
      newAttestationRib.style.display = "block"; */
      this.showAttestationRIB = true;

      var attestation_error = document.getElementById("attestation_rib_error");
      attestation_error.style.display = "none";
    },

    onImageProfilChange(e) {
      var oldP = document.getElementById("oldImageProfile");
      oldP.style.display = "none";

      /* var newIP = document.getElementById("newImageProfilDiv");
      newIP.style.display = "block"; */

      this.imageProfil = e.target.files[0];
      console.log(this.imageProfil);
      let readerP = new FileReader();
      readerP.readAsDataURL(this.imageProfil);
      readerP.onload = (e) => {
        this.imageProfilPreview = e.target.result;
      };

      this.showProfil = true;
    },

    onCVChange(e) {
      this.cv = e.target.files[0];

      if (this.getCV() && this.getCV().path.includes("pdf")) {
        var oldCVpdf = document.getElementById("oldCVpdf");
        oldCVpdf.style.display = "none";
      } else {
        var oldCV = document.getElementById("oldCV");
        oldCV.style.display = "none";
      }

      let readerP = new FileReader();
      readerP.readAsDataURL(this.cv);
      readerP.onload = (e) => {
        this.cvPreview = e.target.result;
      };

      var cv_error = document.getElementById("cv_error");
      cv_error.style.display = "none";
    },

    onDiplomeChange(e) {
      this.diplome = e.target.files[0];

      if (this.getDiplome() && this.getDiplome().path.includes("pdf")) {
        var oldDiplomepdf = document.getElementById("oldDiplomepdf");
        oldDiplomepdf.style.display = "none";
      } else {
        var oldDiplome = document.getElementById("oldDiplome");
        oldDiplome.style.display = "none";
      }

      let readerP = new FileReader();
      readerP.readAsDataURL(this.diplome);
      readerP.onload = (e) => {
        this.DiplomePreview = e.target.result;
      };

      var diplome_error = document.getElementById("diplome_error");
      diplome_error.style.display = "none";
    },

    onCINChange(e) {
      this.cin = e.target.files[0];

      if (this.getCIN() && this.getCIN().path.includes("pdf")) {
        var oldCINpdf = document.getElementById("oldCINpdf");
        oldCINpdf.style.display = "none";
      } else {
        var oldCIN = document.getElementById("oldCIN");
        oldCIN.style.display = "none";
      }

      let readerP = new FileReader();
      readerP.readAsDataURL(this.cin);
      readerP.onload = (e) => {
        this.cinPreview = e.target.result;
      };

      var cin_error = document.getElementById("cin_error");
      cin_error.style.display = "none";
    },

    onCIN2Change(e) {
      this.cin2 = e.target.files[0];

      if (this.getCIN2() && this.getCIN2().path.includes("pdf")) {
        var oldCIN2pdf = document.getElementById("oldCIN2pdf");
        oldCIN2pdf.style.display = "none";
      } else {
        var oldCIN2 = document.getElementById("oldCIN2");
        oldCIN2.style.display = "none";
      }

      let readerP = new FileReader();
      readerP.readAsDataURL(this.cin2);
      readerP.onload = (e) => {
        this.cin2Preview = e.target.result;
      };

      var cin2_error = document.getElementById("cin2_error");
      cin2_error.style.display = "none";
    },

    onAutorisationChange(e) {
      this.autorisation = e.target.files[0];

      if (
        this.getAutorisation() &&
        this.getAutorisation().path.includes("pdf")
      ) {
        var oldAutorisationpdf = document.getElementById("oldAutorisationpdf");
        oldAutorisationpdf.style.display = "none";
      } else {
        var oldAutorisation = document.getElementById("oldAutorisation");
        oldAutorisation.style.display = "none";
      }

      let readerP = new FileReader();
      readerP.readAsDataURL(this.autorisation);
      readerP.onload = (e) => {
        this.autorisationPreview = e.target.result;
      };

      var autorisation_error = document.getElementById("autorisation_error");
      autorisation_error.style.display = "none";
    },

    onAutreChange(e) {
      this.Autre = e.target.files[0];

      if (this.getAutre() && this.getAutre().path.includes("pdf")) {
        var oldAutrepdf = document.getElementById("oldAutrepdf");
        oldAutrepdf.style.display = "none";
      } else {
        var oldAutre = document.getElementById("oldAutre");
        oldAutre.style.display = "none";
      }

      let readerP = new FileReader();
      readerP.readAsDataURL(this.Autre);
      readerP.onload = (e) => {
        this.AutrePreview = e.target.result;
      };
    },

    onPasseportChange(e) {
      this.Passeport = e.target.files[0];

      if (this.getPasseport() && this.getPasseport().path.includes("pdf")) {
        var oldPasseportpdf = document.getElementById("oldPasseportpdf");
        oldPasseportpdf.style.display = "none";
      } else {
        var oldPasseport = document.getElementById("oldPasseport");
        oldPasseport.style.display = "none";
      }

      let readerP = new FileReader();
      readerP.readAsDataURL(this.Passeport);
      readerP.onload = (e) => {
        this.PasseportPreview = e.target.result;
      };
    },

    updateVacataire() {
      let dataP = new FormData();

      Swal.fire({
        title:
          "La confirmation de cette étape est définitive, veuillez valider les renseignements saisis avant de confirmer!",
        showCancelButton: true,
        confirmButtonText: "Confirmer",
        CancelButtonText: "Annuler",
      }).then((result) => {
        if (result.isConfirmed) {
          let config = {
            headers: {
              Authorization: "Bearer " + this.vacataire.api_token,
            },
          };
          dataP.append("photo", this.imageProfil);
          dataP.append("vacataire_id", this.vacataire.id);
          dataP.append("admin_id", this.admin.id);
          dataP.append("cin", this.vacataire.cin);
          dataP.append("regime_affiliation", this.regime_affiliation);
          dataP.append("code_regime_affiliation", this.code_regime_affiliation);
          dataP.append("passport", this.vacataire.passport);
          dataP.append(
            "date_naissance",
            moment(this.vacataire.date_naissance).format("yyyy-MM-DD")
          );
          dataP.append("pays_id", this.vacataire.pays_id);
          dataP.append("adresse", this.vacataire.adresse);
          dataP.append("email_personnel", this.vacataire.email_personnel);
          dataP.append("email_uir", this.vacataire.email_uir);
          dataP.append("tel", this.vacataire.tel);
          dataP.append("profession", this.vacataire.profession);
          dataP.append("dernier_diplome", this.vacataire.dernier_diplome);
          dataP.append("engager", this.vacataire.engager);
          dataP.append("public", this.vacataire.public);
          dataP.append(
            "etablissement_dorigine",
            this.vacataire.etablissement_dorigine
          );
          axios
            .post("/api/vacataire/update/infos", dataP, config)
            .then((response) => {
              this.vacataire.valider = response.data.valider;
              this.current_step = 2;
              this.vacataire.current_step = 2;
              this.errors = {};

              Vue.swal.fire({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
                title: "Les informations personnelles ont été actualisées.",
                icon: "success",
                confirmButtonText: "Cool",
              });
            })
            .catch((error) => {
              this.errors = error.response.data.errors;
            });
        }
      });
    },

    updateBanqueInfo() {
      let data = new FormData();

      if (this.image != null || this.vacataire.attestation_rib_path != null) {
        Swal.fire({
          title:
            "La confirmation de cette étape est définitive, veuillez valider les renseignements saisis avant de confirmer!",
          showCancelButton: true,
          confirmButtonText: "Confirmer",
          CancelButtonText: "Annuler",
        }).then((result) => {
          if (result.isConfirmed) {
            let config = {
              headers: {
                Authorization: "Bearer " + this.vacataire.api_token,
              },
            };

            data.append("vacataire_id", this.vacataire.id);
            data.append("admin_id", this.admin.id);
            data.append("attestation_rib", this.image);
            data.append("banque", this.vacataire.banque);
            data.append("swift", this.vacataire.swift);
            data.append("iban", this.vacataire.iban);
            data.append("rib", this.vacataire.rib);
            axios
              .post("/api/admin/update/banqueInfo", data, config)
              .then((response) => {
                this.vacataire.attestation_rib_path =
                  response.data.attestation_rib_path;
                this.vacataire.current_step = 3;
                this.current_step = 3;
                this.errors = {};

                Vue.swal.fire({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                  title: "Les informations bancaires ont été actualisées.",
                  icon: "success",
                  confirmButtonText: "Cool",
                });
              })
              .catch((error) => {
                this.errors = error.response.data.errors;
              });
          }
        });
      } else {
        var attestation_error = document.getElementById(
          "attestation_rib_error"
        );
        attestation_error.style.display = "block";
      }
    },

    updateDossier() {
      if (
        (this.cv != null || this.getCV() != null) &&
        (this.cin != null || this.getCIN() != null) &&
        (this.cin2 != null || this.getCIN2() != null) &&
        (this.diplome != null || this.getDiplome() != null) &&
        (this.autorisation != null || this.getAutorisation() != null)
      ) {
        Swal.fire({
          title:
            "La confirmation de cette étape est définitive, veuillez valider les renseignements saisis avant de confirmer!",
          showCancelButton: true,
          confirmButtonText: "Confirmer",
          CancelButtonText: "Annuler",
        }).then((result) => {
          if (result.isConfirmed) {
            let data = new FormData();
            let config = {
              headers: {
                Authorization: "Bearer " + this.vacataire.api_token,
              },
            };
            data.append("cv", this.cv);
            data.append("cin", this.cin);
            data.append("cin2", this.cin2);
            data.append("Autorisation", this.autorisation);
            data.append("diplome", this.diplome);
            data.append("autre", this.Autre);
            data.append("passeport", this.Passeport);
            data.append("vacataire_id", this.vacataire.id);
            data.append("admin_id", this.admin.id);

            axios
              .post("/api/admin/update/dossier", data, config)
              .then((response) => {
                this.current_step = 3;
                this.vacataire.valider = 1;
                this.vacataire.current_step = 3;

                //disable enregistrer btn after submiting the form
                var enregistrer = document.getElementById("enregistrer");
                enregistrer.style.display = "none";

                Vue.swal.fire({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                  title: "Les documents ont été actualisées.",
                  icon: "success",
                  confirmButtonText: "Cool",
                });
              })
              .catch((error) => {
                console.log(error);
              });
          }
        });
      }
      if (this.cv == null) {
        if (this.getCV() == null) {
          var cv_error = document.getElementById("cv_error");
          cv_error.style.display = "block";
        }
      }
      if (this.cin == null) {
        if (this.getCIN() == null) {
          var cin_error = document.getElementById("cin_error");
          cin_error.style.display = "block";
        }
      }
      if (this.cin2 == null) {
        if (this.getCIN2() == null) {
          var cin2_error = document.getElementById("cin2_error");
          cin2_error.style.display = "block";
        }
      }
      if (this.diplome == null) {
        if (this.getDiplome() == null) {
          var diplome_error = document.getElementById("diplome_error");
          diplome_error.style.display = "block";
        }
      }
    },

    downloadRegimeAffiliation(id) {
      window.location.href = '/' + this.vacataire.regime_affiliation_file;
    },
  },
  mounted() {
    this.regime_affiliation =
      this.vacataire.regime_type ?? this.vacataire.regime_affiliation;
    this.regime_affiliation_file = this.vacataire.regime_affiliation_file;
    this.code_regime_affiliation =
      this.vacataire.regime_number ?? this.vacataire.code_regime_affiliation;
  },
};
</script>

